import { render, staticRenderFns } from "./gc-footer-sales-order.vue?vue&type=template&id=8025d81c"
import script from "./gc-footer-sales-order.vue?vue&type=script&lang=js"
export * from "./gc-footer-sales-order.vue?vue&type=script&lang=js"
import style0 from "./gc-footer-sales-order.vue?vue&type=style&index=0&id=8025d81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports